import PropTypes from 'prop-types';

/* eslint-disable no-shadow */
const DEFAULT_RATES = {
  SELIC: 2.65, // Yearly
  CDI: 2.65, // Yearly
  POUPANCA: 0.1590, // Monthly
};

export function compoundInterest(amount, interestRate, period) {
  // TODO: extrar (interestRate ** period) em uma variavel
  return amount * (interestRate ** period);
}

export function finalBalance(initialBalance, monthlyDeposit, interestRate, period) {
  if (period < 1) {
    return initialBalance;
  }

  const balance = initialBalance * interestRate + monthlyDeposit;
  return finalBalance(balance, monthlyDeposit, interestRate, period - 1);
}

export function irOnMonthlyDeposits(monthlyDeposit, interestRate, irRate, period, irDue = 0) {
  if (period < 1) {
    return irDue;
  }

  const interest = compoundInterest(monthlyDeposit, interestRate, period - 1);
  const interestWithoutMonthlyDeposit = interest - monthlyDeposit;

  const rate = irRate(period - 1);
  const monthlyRate = interestWithoutMonthlyDeposit * rate;

  return irOnMonthlyDeposits(
    monthlyDeposit,
    interestRate,
    irRate,
    period - 1,
    irDue + monthlyRate,
  );
}

export function irOnInitialBalance(initialBalance, interestRate, irRate, period) {
  const interest = compoundInterest(initialBalance, interestRate, period);
  const interestWithoutInitialBalance = interest - initialBalance;

  return interestWithoutInitialBalance * irRate(period);
}

export function irRate(months) {
  if (months === 0) {
    return 0;
  }

  if (months < 6) {
    return 0.225;
  }

  if (months < 12) {
    return 0.2;
  }

  if (months < 24) {
    return 0.175;
  }

  return 0.15;
}

export function calculateBalance(rates = {}, userParams = {}) {
  const initialBalance = userParams.initialBalance || 0;
  const monthlyDeposits = userParams.monthlyDeposits || 0;
  const period = userParams.period || 0;

  const balance = finalBalance(
    initialBalance,
    monthlyDeposits,
    rates.cdi_monthly_rate,
    period,
  );

  const poupancaBalance = finalBalance(
    initialBalance,
    monthlyDeposits,
    rates.poupanca_monthly_rate,
    period,
  );

  const irOnDeposits = irOnMonthlyDeposits(
    monthlyDeposits,
    rates.cdi_monthly_rate,
    irRate,
    period,
  );

  const irOnBalance = irOnInitialBalance(
    initialBalance,
    rates.cdi_monthly_rate,
    irRate,
    period,
  );

  return {
    finalNuconta: balance,
    finalPop: poupancaBalance,
    liquidBalance: balance - irOnDeposits - irOnBalance,
  };
}

export function calculateYearlyEarnings(annualInterestPercentage, tax = 0.825) {
  const valueInvested = 100;
  const grossValue = (annualInterestPercentage / 100.0 + 1) * valueInvested;
  const earnings = (grossValue - valueInvested) * tax;
  const liquidValue = earnings + valueInvested;
  const result = liquidValue / 100 - 1;

  return result * 100;
}

export function monthlyToYearly(percentage) {
  // TODO: separar em variáveis
  return ((((percentage / 100) + 1) ** 12) - 1) * 100;
}

export function getBaseRates(rates = DEFAULT_RATES) {
  const { SELIC, CDI, POUPANCA } = rates;

  // TODO: remover '_' das variaveis
  return {
    selic: calculateYearlyEarnings(SELIC),
    cdi: CDI,
    // TODO: criar uma função para esse calculo
    cdi_monthly_rate: ((1 + (CDI / 100.0)) ** (1.0 / 252)) ** (252.0 / 12),
    big_banks_cdb: calculateYearlyEarnings(CDI * 0.85),
    poupanca: monthlyToYearly(POUPANCA),
    // TODO: criar uma funcao para gerar um calculo de porcentagem mensal
    poupanca_monthly_rate: (POUPANCA / 100.0) + 1,
  };
}

export const baseRatesPropTypes = PropTypes.shape({
  big_banks_cdb: PropTypes.number,
  cdi: PropTypes.number,
  cdi_monthly_rate: PropTypes.number,
  poupanca: PropTypes.number,
  poupanca_monthly_rate: PropTypes.number,
  selic: PropTypes.number,
});
